import { render, staticRenderFns } from "./MenuBar.vue?vue&type=template&id=02d50bb2&scoped=true"
import script from "./MenuBar.vue?vue&type=script&lang=ts"
export * from "./MenuBar.vue?vue&type=script&lang=ts"
import style0 from "./MenuBar.vue?vue&type=style&index=0&id=02d50bb2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02d50bb2",
  null
  
)

export default component.exports